/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */

/******/
(function () {
  // webpackBootstrap

  /******/
  var __webpack_modules__ = {
    /***/
    "./_src/js/custom.js":
    /*!***************************!*\
      !*** ./_src/js/custom.js ***!
      \***************************/

    /***/
    function () {
      eval("jQuery(function ($) {\n  $('.fs-menu-trigger').click(function (e) {\n    e.preventDefault()\n\n    $('body').toggleClass('menu-opened')\n    $('.mobile-nav-menu').slideToggle(250)\n\n  })\n\n  $('.mobile-submenu-trigger').click(function (e) {\n    e.preventDefault()\n    e.stopPropagation()\n\n    $(this).toggleClass('opened')\n    $(this).parent().find('.site-nav__dropdown').slideToggle()\n  })\n})\n\n\n//# sourceURL=webpack://applesed/./_src/js/custom.js?");
      /***/
    }
    /******/

  };
  /************************************************************************/

  /******/

  /******/
  // startup

  /******/
  // Load entry module and return exports

  /******/
  // This entry module can't be inlined because the eval devtool is used.

  /******/

  var __webpack_exports__ = {};
  /******/

  __webpack_modules__["./_src/js/custom.js"]();
  /******/

  /******/

})();